import Relation from '../common/relation'

const state = Object.assign({}, Relation.state)
state.endpointParent = 'file'
state.endpointChild = 'tag'

export default {
  namespaced: true,
  state,
  getters: Relation.getters,
  mutations: Relation.mutations,
  actions: Relation.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/fileTag.js